function CrmFormControlChangeTab( tabIndex )
{
    for( var i = 0; i < CrmFormControlTabs.length; i++ )
    {
        var tab = document.getElementById(CrmFormControlTabs[i]);
        var header = document.getElementById(CrmFormControlTabHeaders[i]);

        if( i == tabIndex )
        {
            tab.style.display = "block";
            header.className = "activetabheader";
        }
        else
        {
            tab.style.display = "none";
            header.className = "tabheader";
        }
    }
}

function CrmFormControlDisplayInstructions(tabIndex) {
    var message = document.getElementById("ShowTabInstructions" + tabIndex);
    message.style.display = 'none';
    var instructions = document.getElementById("TabInstructions" + tabIndex);
    message.style.display = 'inline';
}

function CrmFormControlHideFormObject(id) {
    CrmFormControlSetStyle(id, 'none');
}

function CrmFormControlShowFormObject(id) {
    CrmFormControlSetStyle(id, 'inline');
}

function CrmFormControlSetStyle(id, style) {
    /* Show sections by the Name attribute */
    if (navigator.appName == 'Microsoft Internet Explorer') {
        /* getElementsByName() doesn't work in IE - so we have to do this hack instead*/
        var divtags = document.getElementsByTagName('div');
        for (var i = 0; i < divtags.length; i++) {
            if (divtags.item(i).getAttribute('name') == id) {
                divtags.item(i).style.display = style;
            }
        }
    }
    else {
        var sections = document.getElementsByName(id)
        for (var i = 0; i < sections.length; i++) {
            sections[i].style.display = style;
        }
    }
    /* Show sections by the ID attribute */
    var item = document.getElementById(id);
    if (item != null && item.value != "") item.style.display = style;
}

function CrmFormControlApplyBooleanFormRules(controlid, sectionsToHide, sectionsToShow, fieldsToHide, fieldsToShow, requiredFieldsToHide, requiredFieldsToShow) {
    var checked = document.getElementById(controlid).checked;
    var hideSectionArray = [];
    var showSectionArray = [];
    var hideFieldArray = [];
    var showFieldArray = [];
    var showRequiredArray = [];
    var hideRequiredArray = [];

    if (sectionsToHide != "") {
        hideSectionArray = sectionsToHide.split(",");
    }
    if (sectionsToShow != "") {
        showSectionArray = sectionsToShow.split(",");
    }
    if (fieldsToHide != "") {
        hideFieldArray = fieldsToHide.split(",");
    }
    if (fieldsToShow != "") {
        showFieldArray = fieldsToShow.split(",");
    }
    if (requiredFieldsToShow != "") {
        showRequiredArray = requiredFieldsToShow.split(",");
    }
    if (requiredFieldsToHide != "") {
        hideRequiredArray = requiredFieldsToHide.split(",");
    }

    if (checked) {
        // Section visibility
        for (var i = 0; i < showSectionArray.length; i++) {
            CrmFormControlShowFormObject(showSectionArray[i]);
        }
        for (i = 0; i < hideSectionArray.length; i++) {
            CrmFormControlHideFormObject(hideSectionArray[i]);
        }
        // Field visibility
        for (var i = 0; i < showFieldArray.length; i++) {
            CrmFormControlShowFormObject(showFieldArray[i]);
        }
        for (i = 0; i < hideFieldArray.length; i++) {
            CrmFormControlHideFormObject(hideFieldArray[i]);
        }
        // Field required
        for (i = 0; i < showRequiredArray.length; i++) {
            CrmFormControlShowRequiredField(showRequiredArray[i]);
        }
        for (i = 0; i < hideRequiredArray.length; i++) {
            CrmFormControlHideRequiredField(hideRequiredArray[i]);
        }
    }
    //This clause is used only in the checkbox, not the radio button case.
    //Note the method calls are reversed.
    if (!checked) {
        // Section Visibility
        for (var i = 0; i < showSectionArray.length; i++) {
            CrmFormControlHideFormObject(showSectionArray[i]);
        }
        for (i = 0; i < hideSectionArray.length; i++) {
            CrmFormControlShowFormObject(hideSectionArray[i]);
        }
        // Field visibility
        for (var i = 0; i < showFieldArray.length; i++) {
            CrmFormControlHideFormObject(showFieldArray[i]);
        }
        for (i = 0; i < hideFieldArray.length; i++) {
            CrmFormControlShowFormObject(hideFieldArray[i]);
        }
        // Field required
        for (i = 0; i < showRequiredArray.length; i++) {
            CrmFormControlHideRequiredField(showRequiredArray[i]);
        }
        for (i = 0; i < hideRequiredArray.length; i++) {
            CrmFormControlShowRequiredField(hideRequiredArray[i]);
        }
    }
}

function CrmFormControlApplyDropdownFormRulesUsingSuppliedValue(controlid, conditionallyAffectedSectionsString, conditionallyAffectedFieldsString, requiredFieldsString, isBoolean, selectedValue) {
    // Conditional Sections
    var conditionallyAffectedSections = [];
    if (conditionallyAffectedSectionsString != "") {
        conditionallyAffectedSections = conditionallyAffectedSectionsString.split("|");
    }

    var conditionallyAffectedSection = [];
    for (var i = 0; i < conditionallyAffectedSections.length; i++) {
        conditionallyAffectedSection = conditionallyAffectedSections[i].split(";");
        var affectedSectionID = conditionallyAffectedSection[0];
        var operator = conditionallyAffectedSection[1];
        var values = conditionallyAffectedSection[2].toLowerCase().split(",");
        var isNullIncluded = conditionallyAffectedSection[3];

        // Determine if the current selected value is contained in the conditional values array
        var containsCurrentValue = false;

        //The null value is selected
        if ((selectedValue == "0" || selectedValue == "") && isBoolean != "true") {
            if (isNullIncluded == "true") {
                containsCurrentValue = true;
            }
        }
            //A non-null value is selected
        else {
            for (var j = 0; j < values.length; j++) {
                if (values[j] == selectedValue) {
                    containsCurrentValue = true;
                    break;
                }
            }
        }

        if (containsCurrentValue) {
            switch (operator) {
                case "includes":
                    CrmFormControlShowFormObject(affectedSectionID);
                    break;
                case "excludes":
                    CrmFormControlHideFormObject(affectedSectionID);
                    break;
            }
        }
        else {
            switch (operator) {
                case "includes":
                    CrmFormControlHideFormObject(affectedSectionID);
                    break;
                case "excludes":
                    CrmFormControlShowFormObject(affectedSectionID);
                    break;
            }
        }
    }

    // Conditional fields
    var conditionallyAffectedFields = [];
    if (conditionallyAffectedFieldsString != "") {
        conditionallyAffectedFields = conditionallyAffectedFieldsString.split("|");
    }

    var conditionallyAffectedField = [];
    for (var i = 0; i < conditionallyAffectedFields.length; i++) {
        conditionallyAffectedField = conditionallyAffectedFields[i].split(";");
        var affectedFieldID = conditionallyAffectedField[0];
        var operator = conditionallyAffectedField[1];
        var values = conditionallyAffectedField[2].toLowerCase().split(",");
        var isNullIncluded = conditionallyAffectedField[3];

        // Determine if the current selected value is contained in the conditional values array
        var containsCurrentValue = false;

        //The null value is selected
        if ((selectedValue == "0" || selectedValue == "") && isBoolean != "true") {
            if (isNullIncluded == "true") {
                containsCurrentValue = true;
            }
        }
            //A non-null value is selected
        else {
            for (var j = 0; j < values.length; j++) {
                if (values[j] == selectedValue) {
                    containsCurrentValue = true;
                    break;
                }
            }
        }

        if (containsCurrentValue) {
            switch (operator) {
                case "includes":
                    CrmFormControlShowFormObject(affectedFieldID);
                    break;
                case "excludes":
                    CrmFormControlHideFormObject(affectedFieldID);
                    break;
            }
        }
        else {
            switch (operator) {
                case "includes":
                    CrmFormControlHideFormObject(affectedFieldID);
                    break;
                case "excludes":
                    CrmFormControlShowFormObject(affectedFieldID);
                    break;
            }
        }
    }

    //process conditionally required fields
    var conditionallyRequiredFields = [];
    if (requiredFieldsString != "") {
        conditionallyRequiredFields = requiredFieldsString.split("|");
    }

    var conditionallyRequiredField = [];
    for (var i = 0; i < conditionallyRequiredFields.length; i++) {
        conditionallyRequiredField = conditionallyRequiredFields[i].split(";");
        var requiredFieldID = conditionallyRequiredField[0];
        var operator = conditionallyRequiredField[1];
        var values = conditionallyRequiredField[2].toLowerCase().split(",");
        var isNullIncluded = conditionallyRequiredField[3];

        // Determine if the current selected value is contained in the conditional values array
        var containsCurrentValue = false;

        //The null value is selected
        if ((selectedValue == "0" || selectedValue == "") && isBoolean != "true") {
            if (isNullIncluded == "true") {
                containsCurrentValue = true;
            }
        }
            //A non-null value is selected
        else {
            for (var j = 0; j < values.length; j++) {
                if (values[j] == selectedValue) {
                    containsCurrentValue = true;
                    break;
                }
            }
        }

        if (containsCurrentValue) {
            switch (operator) {
                case "includes":
                    CrmFormControlShowRequiredField(requiredFieldID);
                    break;
                case "excludes":
                    CrmFormControlHideRequiredField(requiredFieldID);
                    break;
            }
        }
        else {
            switch (operator) {
                case "includes":
                    CrmFormControlHideRequiredField(requiredFieldID);
                    break;
                case "excludes":
                    CrmFormControlShowRequiredField(requiredFieldID);
                    break;
            }
        }
    }
}

function CrmFormControlApplyDropdownFormRules(controlid, conditionallyAffectedSectionsString, conditionallyAffectedFieldsString, requiredFieldsString, isBoolean) {
    var dropdownObject = document.getElementById(controlid);
    var dropdownSelectedValue = dropdownObject.options[dropdownObject.selectedIndex].value;
    CrmFormControlApplyDropdownFormRulesUsingSuppliedValue(controlid, conditionallyAffectedSectionsString, conditionallyAffectedFieldsString, requiredFieldsString, isBoolean, dropdownSelectedValue);
}

function CrmFormControlApplyTextFormRules(controlid, conditionallyAffectedSectionsString) {
    var textInput = document.getElementById(controlid).value;

    var conditionallyAffectedSections = [];
    if (conditionallyAffectedSectionsString != "") {
        conditionallyAffectedSections = conditionallyAffectedSectionsString.split("|");
    }

    var conditionallyAffectedSection = [];
    for (var i = 0; i < conditionallyAffectedSections.length; i++) {
        conditionallyAffectedSection = conditionallyAffectedSections[i].split(";");
        var affectedSectionID = conditionallyAffectedSection[0];
        var operator = conditionallyAffectedSection[1];
        var value = conditionallyAffectedSection[2];
        var isNullIncluded = conditionallyAffectedSection[3];

        // Determine if the current selected value is contained in the conditional values array
        var containsCurrentValue = false;

        //The null value is selected
        if (textInput == null || textInput == "") {
            if (isNullIncluded == "true") {
                containsCurrentValue = true;
            }
        }
        //A non-null value is selected
        else {
            // Determine if the current user text input matches the value contained in the conditional value
            var containsCurrentValue = textInput.toLowerCase() == value.toLowerCase();
        }

        if (containsCurrentValue) {
            switch (operator) {
                case "includes":
                    CrmFormControlShowFormObject(affectedSectionID);
                    break;
                case "excludes":
                    CrmFormControlHideFormObject(affectedSectionID);
                    break;
            }
        }
        else {
            switch (operator) {
                case "includes":
                    CrmFormControlHideFormObject(affectedSectionID);
                    break;
                case "excludes":
                    CrmFormControlShowFormObject(affectedSectionID);
                    break;
            }
        }
    }
}

function CrmFormControlShowRequiredField(requiredfieldid) {
    var field = document.getElementById(requiredfieldid);
    if (field != null) {
        var oldclasses = field.className;
        var requiredText = " required";
        if (oldclasses.indexOf(requiredText) == -1) {
            //add the 'required' class
            field.className = oldclasses + requiredText;
            //make the asterisk visible
            var spans = field.getElementsByTagName("span");
            if (spans != null && spans.length > 0) {
                if (spans[0].innerHTML == "*") {
                    spans[0].style.cssText = "visibility:visible";
                }
            }
            //enable field validator
            for (i = 0; i < spans.length; i++) {
                var idstring = spans[i].getAttribute("id");
                if ((idstring != null) && (idstring.indexOf("requiredvalidator") != -1)) {
                    var validator = document.getElementById(idstring);
                    ValidatorEnable(validator, true);
                    //necessary because ValidatorEnable shows the field automatically, which we don't want
                    validator.style.cssText = "display:none";
                }
            }
        }
    }
}

function CrmFormControlHideRequiredField(requiredfieldid) {
    var field = document.getElementById(requiredfieldid);
    if (field != null) {
        var oldclasses = field.className;
        var requiredText = " required";
        if (oldclasses.indexOf(requiredText) != -1) {
            //remove the 'required' class
            field.className = oldclasses.substring(0, oldclasses.indexOf(requiredText));
            //hide the asterisk
            var spans = field.getElementsByTagName("span");
            if (spans != null && spans.length > 0) {
                if (spans[0].innerHTML == "*") {
                    spans[0].style.cssText = "visibility:hidden";
                }
            }
            //disable field validator
            for (i = 0; i < spans.length; i++) {
                var idstring = spans[i].getAttribute("id");
                if ((idstring != null) && (idstring.indexOf("requiredvalidator") != -1)) {
                    var validator = document.getElementById(idstring);
                    ValidatorEnable(validator, false);
                    //necessary because ValidatorEnable shows the field automatically, which we don't want
                    validator.style.cssText = "display:none";
                }
            }
        }
    }
}

String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

function ValidateMultiselectControl(source, args) {
    var parent = source.parentElement;

    var min = 0;
    var max = 0;
    for (var i = 0; i < parent.children.length; i++) {
        if (parent.children[i].id.endsWith("MinimumRequiredChecks"))
            min = parseInt(parent.children[i].value);
        if (parent.children[i].id.endsWith("MaximumAllowedChecks"))
            max = parseInt(parent.children[i].value);
    }

    var checkboxes = new Array();
    FindCheckboxes(parent, checkboxes);

    var checked = 0;
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked)
            checked++;
    }

    if (min > 0 && checked < min) {
        args.IsValid = false;
        return;
    }
    if (max > 0 && checked > max) {
        args.IsValid = false;
        return;
    }
}


function FindCheckboxes(node, list) {
    if (node.children == null)
        return;
    for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i];
        if (child.tagName == "INPUT" && child.type == "checkbox")
            list.push(child);
        FindCheckboxes(child, list);
    }
}

module.exports = {
  CrmFormControlApplyDropdownFormRules: CrmFormControlApplyDropdownFormRules,
  CrmFormControlApplyBooleanFormRules: CrmFormControlApplyBooleanFormRules
};
